import { useParams } from 'react-router'
import { PARAM } from '@App/navigation/param'
import { StoresContext } from '@App/contexts'
import React, { useContext, useEffect } from 'react'
import CatalogTransferWizard from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { observer } from 'mobx-react'
import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'
import { CatalogTransferWizardStep } from '@Const/catalog-transfer-wizard-step'

const CatalogTransferWizardLanding = () => {
    const {
        catalogTransferWizardStore,
        wizardFlowStore,
        transferSourcePublisherSearchStore,
        transferTargetPublisherSearchStore,
    } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()

    useEffect(() => {
        const transferId = Number(params.transferId)

        catalogTransferWizardStore.setCurrentCatalogTransfer(transferId).then(() => {
            const transfer = catalogTransferWizardStore.currentCatalogTransfer
            if (transfer) {
                wizardFlowStore.setCurrentIndex(loadWizardLocation(transfer))
            }
        })

        return () => {
            wizardFlowStore.resetStore()
            catalogTransferWizardStore.resetStoreAfterWizard()
            transferSourcePublisherSearchStore.resetStore()
            transferTargetPublisherSearchStore.resetStore()
        }
    }, [])

    const loadWizardLocation = (currentCatalogTransfer: CatalogTransferView): number => {
        if (
            currentCatalogTransfer.isPartialTransfer === null ||
            currentCatalogTransfer.isPartialTransfer === undefined
        ) {
            return CatalogTransferWizardStep.SelectTransferType
        } else if (!currentCatalogTransfer.sourcePublishers?.length) {
            return CatalogTransferWizardStep.SourcePublisher
        } else if (currentCatalogTransfer.exportedAt === null || currentCatalogTransfer.exportedAt === undefined) {
            return CatalogTransferWizardStep.VerifyWorks
        } else if (
            currentCatalogTransfer.workCount === undefined ||
            currentCatalogTransfer.workCount === 0 ||
            currentCatalogTransfer.workCount === null
        ) {
            return CatalogTransferWizardStep.ImportCatalog
        } else if (!currentCatalogTransfer.targetPublisher) {
            return CatalogTransferWizardStep.TargetPublisher
        } else if (!currentCatalogTransfer.uploadedDocs.find((doc) => doc.uploadType === 'DOCUMENTATION')) {
            return CatalogTransferWizardStep.UploadDocumentation
        } else if (!currentCatalogTransfer.effectiveDate) {
            return CatalogTransferWizardStep.ExtraInfo
        } else {
            return CatalogTransferWizardStep.Review
        }
    }

    return (
        <>
            {catalogTransferWizardStore.currentCatalogTransfer ? (
                <CatalogTransferWizard type={catalogTransferWizardStore.currentCatalogTransfer?.catalogTransferType} />
            ) : (
                <PointPreloader />
            )}
        </>
    )
}

export default observer(CatalogTransferWizardLanding)
